import { isIOSDevice } from "./runtime_platform.js";

const OVERRIDE_KEY = "perf_low_memory";

let cached: boolean | null = null;

const readOverride = (): boolean | null =>
{
  try
  {
    const value = localStorage.getItem( OVERRIDE_KEY );
    if ( value === "1" ) return true;
    if ( value === "0" ) return false;
  }
  catch
  {
  }
  return null;
};

export const isMemoryConstrained = (): boolean =>
{
  if ( cached === null )
    cached = readOverride() ?? isIOSDevice();
  return cached;
};
